/*
  Trailblazer PDP test (template: product.trailblazer-size)
  1. Size system toggle: EU / US (W/M). Relabels the size pills only;
     the variant values stay "EU 37".."EU 45", so cart, inventory and apps are untouched.
  2. Market shipping box: country by IP (Shopify browsing_context_suggestions),
     delivery window from measured order-to-door times, duties line from the
     published shipping policy (Redo help centre, "International Shipping & Return Fees").

  Conversions come from the supplier chart (size_chart metaobject "trailblazer-sandal": EU 41 = US M9 = US W10).
  AU/UK option removed 27 Sep 2026 (confusing on a unisex size run). AU/UK = US Men minus 1 if it comes back.

  The main section is swapped by AJAX on colour change (zorali-pdp.js) and the
  variant picker is re-rendered on size change, so everything re-applies from a
  MutationObserver rather than running once.
*/
(function () {
  if (window.__zoraliTbPdp) return;
  window.__zoraliTbPdp = true;

  var STORE_KEY = 'zorali_tb_size_system';
  var SYSTEMS = [
    { id: 'eu', label: 'EU' },
    { id: 'us', label: 'US' }
  ];

  function sizeLabel(eu, system) {
    if (system === 'us') return 'W' + (eu - 31) + ' / M' + (eu - 32);
    return String(eu);
  }

  // Business days from DISPATCH to delivery. Measured = p25..p85 of Shopify fulfilments
  // 27 May - 24 Sep 2026 with a carrier delivery scan (transit_windows_measured.json).
  // Policy = help-centre transit range, used where we have too few delivery scans.
  var EU27 = 'LV LT AT BE BG CY CZ DE DK EE ES FI FR GR HR HU IE IT LU MT NL PL PT RO SE SI SK'.split(' ');
  var ASIA = 'AE BH BN CN CY HK ID IL IN JO JP KR KW MO MY OM PH QA SA TH TR VN'.split(' ');
  var WINDOWS = {
    AU: [1, 4],   // measured, n=7,097
    US: [3, 10],  // SEKO policy from 15 Oct 2026 (was DHL Express, measured 3-5, n=553)
    GB: [5, 8],   // measured, n=824
    CA: [5, 12],  // measured, n=44
    MX: [4, 7],   // measured, n=96
    CH: [3, 5],   // measured, n=38
    NO: [3, 6],   // measured, n=31
    AE: [2, 4],   // measured, n=25
    NZ: [2, 5],   // measured 2-4 (n=19), policy 3-7
    SG: [4, 8],   // policy
    EU: [3, 9],   // measured 3-6 (n=39, thin), policy 3-10
    ASIA: [7, 14],// policy
    ROW: [4, 8]   // DHL Express lanes, MX used as the measured proxy
  };

  // Black Bear SLA: weekday orders before 12pm Melbourne time ship the same day.
  var CUTOFF_HOUR = 12;
  // Victorian public holidays (weekdays only), from business.vic.gov.au. No dispatch on these.
  // 2027 AFL Grand Final Friday is not announced yet: add it when the AFL fixture is out.
  var VIC_HOLIDAYS = [
    '2026-01-01','2026-01-26','2026-03-09','2026-04-03','2026-04-06','2026-06-08','2026-09-25','2026-11-03','2026-12-25','2026-12-28',
    '2027-01-01','2027-01-26','2027-03-08','2027-03-26','2027-03-29','2027-06-14','2027-11-02','2027-12-27','2027-12-28'
  ];
  // Carriers are closed almost everywhere on these, so international transit skips them too.
  var GLOBAL_CLOSED = ['12-25', '12-26', '01-01'];

  // Free-shipping thresholds per market, same values as snippets/free-shipping-bar.liquid, the market announcement bar
  // and the Daylight info box (AU $200, NZ $200 NZD, GB £120, EU €139), verified 7 Oct 2026 against live checkout rates.
  // CA $200 CAD and SG S$200 confirmed by Cam from Shopify Markets shipping rates, 8 Oct 2026.
  // US free over US$150 from 15 Oct 2026 (SEKO, duties included; US$15 flat rate confirmed 26 Oct 2026; Intelligems test ended).
  // Other markets have no free-shipping offer. Added 8 Oct 2026.
  function freeShipLine(cc) {
    if (cc === 'AU') return 'Free shipping on orders $200+.';
    if (cc === 'NZ') return 'Free shipping on orders over $200 NZD.';
    if (cc === 'GB') return 'Free shipping on orders over \u00a3120.';
    if (cc === 'CA') return 'Free shipping on orders over $200 CAD.';
    if (cc === 'SG') return 'Free shipping on orders over S$200.';
    if (cc === 'US') return 'US$15 shipping. Free on orders US$150 and over.';
    if (EU27.indexOf(cc) > -1) return 'Free shipping on orders over \u20ac139.';
    return '';
  }

  // Policy: duties & taxes included for these; everywhere else payable by the receiver.
  var DDP = ['US', 'GB', 'CA', 'NZ', 'SG', 'MX', 'CH', 'NO'].concat(EU27);

  // How each market names itself, so the box reads local ("across the UK", not "to United Kingdom").
  var LOCAL_NAMES = {
    GB: 'the UK', US: 'the US', NL: 'the Netherlands', AE: 'the UAE', PH: 'the Philippines',
    CZ: 'Czechia', KR: 'South Korea', HK: 'Hong Kong', DO: 'the Dominican Republic', BS: 'the Bahamas'
  };
  function localName(cc, name) { return LOCAL_NAMES[cc] || name || cc; }

  // Keep the flag glued to the heading's last word so it never wraps onto its own line.
  function withFlag(text, flagImg) {
    var t = escapeHtml(text), i = t.lastIndexOf(' ');
    return (i > -1 ? t.slice(0, i + 1) : '') + '<span class="tbz-nowrap">' + t.slice(i + 1) + flagImg + '</span>';
  }

  function windowFor(cc) {
    if (WINDOWS[cc]) return WINDOWS[cc];
    if (EU27.indexOf(cc) > -1) return WINDOWS.EU;
    if (ASIA.indexOf(cc) > -1) return WINDOWS.ASIA;
    return WINDOWS.ROW;
  }

  function defaultSystem(cc) {
    if (cc === 'US' || cc === 'CA' || cc === 'AU') return 'us';
    return 'eu';
  }

  function safeGet(store, k) { try { return store.getItem(k); } catch (e) { return null; } }
  function safeSet(store, k, v) { try { store.setItem(k, v); } catch (e) {} }

  var country = null;
  var countryName = null;
  var system = safeGet(localStorage, STORE_KEY);
  if (system === 'auuk') system = null; // retired option; fall back to the market default

  function ymd(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function isWorkday(d, domestic) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    var key = ymd(d);
    if (domestic) return VIC_HOLIDAYS.indexOf(key) === -1;
    return GLOBAL_CLOSED.indexOf(key.slice(5)) === -1;
  }
  function addWorkdays(from, n, domestic) {
    var d = new Date(from.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d, domestic)) n--;
    }
    return d;
  }

  // Calendar date + hour in Melbourne (handles AEST/AEDT), as a local-midnight Date.
  function melbourneNow() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Melbourne', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { date: new Date(+parts.year, +parts.month - 1, +parts.day), hour: +parts.hour };
    } catch (e) {
      var now = new Date();
      var mel = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + 10 * 3600000);
      return { date: new Date(mel.getFullYear(), mel.getMonth(), mel.getDate()), hour: mel.getHours() };
    }
  }

  // The day the order leaves the warehouse (VIC workdays only; Black Bear SLA cutoff).
  function dispatchInfo() {
    var now = melbourneNow();
    var dispatchable = VIC_HOLIDAYS.indexOf(ymd(now.date)) === -1 && now.date.getDay() % 6 !== 0;
    if (dispatchable && now.hour < CUTOFF_HOUR) return { date: now.date, today: true, now: now };
    return { date: addWorkdays(now.date, 1, true), today: false, now: now };
  }

  function dayWord(from, to) {
    var diff = Math.round((to - from) / 86400000);
    if (diff === 1) return 'tomorrow';
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][to.getDay()];
  }

  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  // "Tue 29 Sep", or "Tue, Sep 29" for North America.
  function fmt(d, cc) {
    if (cc === 'US' || cc === 'CA') return WD[d.getDay()] + ', ' + MO[d.getMonth()] + ' ' + d.getDate();
    return WD[d.getDay()] + ' ' + d.getDate() + ' ' + MO[d.getMonth()];
  }

  /* ---------- size toggle ---------- */

  function sizeFieldset(root) {
    var inputs = root.querySelectorAll('.product-form__input--pill input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (/^EU\s*\d+/.test(inputs[i].value)) return inputs[i].closest('fieldset');
    }
    return null;
  }

  function applySizes() {
    var fs = sizeFieldset(document);
    if (!fs) return;
    fs.classList.add('tbz-sizes');
    var legend = fs.querySelector('.prod_page_legend');

    if (legend && !legend.querySelector('.tbz-toggle')) {
      var wrap = document.createElement('div');
      wrap.className = 'tbz-toggle';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Size system');
      SYSTEMS.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = s.label;
        b.setAttribute('data-system', s.id);
        wrap.appendChild(b);
      });
      legend.appendChild(wrap);
    }

    // The Size Guide link is server-rendered on this legend row (snippets/zorali-size-guide.liquid,
    // class tbz-guide) before the toggle appended above, so there is nothing to move.

    var active = system || 'eu';
    fs.querySelectorAll('.tbz-toggle button').forEach(function (b) {
      var on = b.getAttribute('data-system') === active;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    fs.classList.toggle('tbz-sys-us', active === 'us');

    fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var m = input.value.match(/^EU\s*(\d+)/);
      if (!m) return;
      var label = fs.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var text = sizeLabel(parseInt(m[1], 10), active);
      var span = label.querySelector('.tbz-size');
      if (!span) {
        // Replace the leading text node ("EU 37") and keep Shopify's hidden unavailable text.
        for (var n = label.firstChild; n; n = n.nextSibling) {
          if (n.nodeType === 3 && n.textContent.trim()) { label.removeChild(n); break; }
        }
        span = document.createElement('span');
        span.className = 'tbz-size';
        label.insertBefore(span, label.firstChild);
      }
      if (span.textContent !== text) span.textContent = text;
      label.setAttribute('title', 'EU ' + m[1]);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tbz-toggle button');
    if (!b) return;
    e.preventDefault();
    system = b.getAttribute('data-system');
    safeSet(localStorage, STORE_KEY, system);
    applySizes();
  });

  /* ---------- shipping box ---------- */

  var ICONS = {
    returns: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20 12a8 8 0 0 1-14.3 4.9M4 12a8 8 0 0 1 14.3-4.9"/><path d="M18.5 3v4.2h-4.2M5.5 21v-4.2h4.2"/></svg>',
    duties: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10" rx="1.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/><circle cx="12" cy="15" r="1.3"/><path d="M12 16.3v1.7"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>'
  };

  function selectedInput() {
    var fs = sizeFieldset(document);
    return fs ? fs.querySelector('input[type="radio"]:checked') : null;
  }

  function renderShipping() {
    var box = document.querySelector('[data-tbz-ship]');
    if (!box || !country) return;
    var cc = country;
    var disp = dispatchInfo();
    var key = cc + '|' + (selectedInput() ? selectedInput().value : '') + '|' + ymd(disp.date) + disp.today;
    if (box.getAttribute('data-rendered') === key) return;

    var name = countryName || cc;
    var intl = cc !== 'AU';
    var input = selectedInput();
    var preorder = input && input.getAttribute('data-pre-order-date');
    var soldOut = input && input.classList.contains('disabled') && !preorder;

    var arrive;
    var ships = '';
    if (preorder) {
      arrive = 'Pre-order: ships from ' + preorder;
    } else if (soldOut) {
      arrive = '';
    } else {
      var w = windowFor(cc);
      var domestic = !intl;
      arrive = 'Arrives ' + fmt(addWorkdays(disp.date, w[0], domestic), cc) + ' \u2013 ' + fmt(addWorkdays(disp.date, w[1], domestic), cc);
      // Only mention dispatch when it is a reason to buy now; the AU title already says "shipping daily".
      if (domestic && disp.today) ships = 'Order by 12pm, ships today.';
    }

    var rows = [];
    var flag = 'https://cdn.shopify.com/static/images/flags/' + cc.toLowerCase() + '.svg';
    var flagImg = ' <img class="tbz-ship__flag" src="' + flag + '" alt="" width="21" height="14" loading="lazy" onerror="this.remove()">';
    if (intl) {
      rows.push({
        icon: ICONS.truck,
        title: withFlag('Tracked delivery across ' + localName(cc, name), flagImg),
        text: [freeShipLine(cc), arrive ? escapeHtml(arrive) + '.' : 'Tracked door-to-door delivery.'].filter(Boolean).join(' ')
      });
    } else {
      rows.push({
        icon: ICONS.truck,
        title: '<span class="tbz-desk">' + withFlag('Aussie owned, shipping daily from Melbourne', flagImg) + '</span>' +
          '<span class="tbz-mob">' + withFlag('Ships daily from Melbourne', flagImg) + '</span>',
        text: [freeShipLine(cc), ships, arrive ? escapeHtml(arrive) + ' with Australia Post.' : 'Tracked with Australia Post.'].filter(Boolean).join(' ')
      });
    }
    rows.push({ icon: ICONS.returns, title: '30-day returns and exchanges' });
    if (intl) {
      rows.push(DDP.indexOf(cc) > -1
        ? { icon: ICONS.duties, title: 'Duties and taxes included' }
        : { icon: ICONS.duties, title: 'Duties and taxes paid on delivery' });
    }
    // Lifetime Repairs: read from the existing info block so theme-editor edits still flow through.
    var repair = document.querySelector('.custom_info_boxes_main .custom_info_box');
    if (repair) {
      var rImg = repair.querySelector('img');
      var rTitle = repair.querySelector('h4');
      var rText = repair.querySelector('.info_custom_content');
      if (rTitle) {
        rows.push({
          icon: rImg ? '<img src="' + rImg.getAttribute('src') + '" alt="" width="20" height="18">' : '',
          title: escapeHtml(rTitle.textContent.trim()),
          text: rText ? rText.innerHTML : '',
          rawText: true
        });
      }
    }

    box.innerHTML = rows.map(function (r) {
      return '<div class="tbz-ship__row">' +
        '<div class="tbz-ship__title"><span class="tbz-ship__icon">' + r.icon + '</span><h4>' + r.title + '</h4></div>' +
        (r.text ? '<div class="tbz-ship__text">' + (r.rawText ? r.text : '<p>' + r.text + '</p>') + '</div>' : '') +
      '</div>';
    }).join('');
    box.hidden = false;
    document.body.classList.add('tbz-atc-active');
    box.setAttribute('data-rendered', key);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- country detection ---------- */

  function setCountry(cc, name) {
    country = String(cc).toUpperCase();
    countryName = name;
    if (!system) system = defaultSystem(country);
    applyAll();
  }

  function displayCountryName(cc) {
    try {
      var locale = document.documentElement.lang || 'en';
      return new Intl.DisplayNames([locale], { type: 'region' }).of(cc);
    } catch (e) {
      return null;
    }
  }

  function detectCountry() {
    // The selected Shopify market is authoritative. A shopper may deliberately browse a
    // different market from their current IP, and all price, tax and delivery messaging
    // must stay aligned with that selection.
    var sc = window.Shopify && window.Shopify.country;
    if (sc) {
      sc = String(sc).toUpperCase();
      setCountry(sc, displayCountryName(sc));
      return;
    }

    var cached = safeGet(sessionStorage, 'zorali_tb_country');
    if (cached) {
      try { var c = JSON.parse(cached); setCountry(c.cc, c.name); return; } catch (e) {}
    }
    // Fallback while the IP lookup runs: the market the shopper is browsing in.
    var sc = window.Shopify && window.Shopify.country;
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        if (!c || !c.handle) throw new Error('no country');
        safeSet(sessionStorage, 'zorali_tb_country', JSON.stringify({ cc: c.handle, name: c.name }));
        setCountry(c.handle, c.name);
      })
      .catch(function () {

      });
  }

  /* ---------- wiring ---------- */

  var queued = false;
  function applyAll() {
    queued = false;
    applySizes();
    renderShipping();
  }
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(applyAll, 30);
  }

  // Styles the script's own markup depends on. Shipped with the script (not only in the template)
  // so a Cloudflare-cached page with an older <style> can never show both headings.
  function injectCss() {
    if (document.getElementById('tbz-js-css')) return;
    var st = document.createElement('style');
    st.id = 'tbz-js-css';
    st.textContent = '.tbz-ship{margin:15px 0;background:#f2f2f2;border-radius:10px;padding:15px 20px;display:grid;gap:16px;font-family:Poppins,sans-serif}.tbz-ship__title{display:flex;align-items:center;gap:10px}.tbz-ship__icon{flex:0 0 20px;display:flex;align-items:center;justify-content:center;color:#1c1d1d}.tbz-ship__icon img{width:20px;height:auto}.tbz-ship h4{margin:0;font-size:14px;font-weight:600;line-height:18.2px;color:#1c1d1d;letter-spacing:normal;display:block}.tbz-nowrap{white-space:nowrap}.tbz-mob{display:none}.tbz-ship__flag{display:inline-block;vertical-align:-2px;margin-left:6px;border-radius:2px;box-shadow:0 0 0 1px rgba(0,0,0,.08)}.tbz-ship__text{padding:10px 0 0}.tbz-ship__text p{margin:0;font-size:13px;line-height:18px;color:#000;letter-spacing:normal}.tbz-atc-active .custom_info_boxes_main{display:none}' +
      '@media (max-width:749px){.tbz-desk{display:none}.tbz-mob{display:inline}}';
    document.head.appendChild(st);
  }

  function start() {
    injectCss();
    applyAll();
    detectCountry();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    setInterval(queue, 60000);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.tbz-sizes input[type="radio"]')) queue();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
